<template>
  <div
    :class="$style.component"
    ref="textRef"
  >
    <ClockIcon :class="$style.clockIcon" :size="22" color="white" />
    <span :Class="$style.text">
      {{formatTime(time)}}
    </span>
  </div>
</template>

<script>
import {ref} from '@vue/composition-api'

import ClockIcon from '@/components/ClockIcon'
import useIntervals from '@/composition/useIntervals'
import useZoom from '@/composition/useZoom'
import {formatTime} from '@/utils/time'

export default {
  setup () {
    const startTime = Date.now()
    const time = ref(0)
    const setInterval = useIntervals()
    const textRef = ref()

    useZoom(textRef, 1.5)

    setInterval(() => {
      time.value = Math.floor((Date.now() - startTime))
    }, 1000)

    return {
      textRef,
      formatTime,
      time,
      getTime () {
        return Date.now() - startTime
      },
    }
  },
  components: {
    ClockIcon,
  },
}

</script>

<style module lang="scss">
.component {
  display: flex;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding: variables.$spacing-16 variables.$spacing-40;
  font-family: variables.$font-family-body;
  font-size: variables.$font-size-m-body;
  font-weight: variables.$font-weight-m-body;
  line-height: 1;
  color: white;
  background-color: rgba(#001722, 0.8);

  .clockIcon {
    margin-right: variables.$spacing-8;
  }

  .text {
    min-width: 65px;
    text-align: center;
  }
}
</style>
